import axios from 'axios'
import config from '@/config'
const HOST = isProduction() ? 'api-xl9-ssl.xunlei.com' : 'api.xl9.xunlei.com'

const getcookie = name => {
  return decodeURIComponent(
    document.cookie.match(
      new RegExp('(^' + name + '| ' + name + ')=([^;]*)')
    ) == null
      ? ''
      : RegExp.$2
  )
}

const instance = axios.create({
  baseURL: `${protocal()}://${HOST}/xlws/`,
  timeout: 10000,
  withCredentials: false
})

/**
 * 获取验证码 api
 *
 * @param {string} tel
 * @returns
 */
function getCaptcha(tel) {
  return axios({
    method: 'post',
    url: `${protocal()}://${HOST}/xlws/benefit/get_captcha`,
    headers: {
      deviceid: getcookie('deviceid'),
      creditkey: getcookie('creditkey')
    },
    data: {
      tel: tel
    }
  })
}

/**
 * 验证验证码api
 *
 * @param {string} 电话
 * @param {string} 渠道
 * @param {number} 验证码
 * @returns
 */
function codeValidate(tel, from, code) {
  return axios({
    method: 'post',
    url: `${protocal()}://${HOST}/xlws/benefit/code_validate`,
    headers: {
      deviceid: getcookie('deviceid'),
      creditkey: getcookie('creditkey')
    },
    data: {
      code: code,
      tel: tel,
      from: from
    }
  })
}

function isProduction() {
  return config.shouleiAPI === 'prod'
}

function protocal() {
  return `http${isProduction() ? 's' : ''}`
}

function getBenefitConfiguration() {
  const src = isProduction()
    ? 'https://api-shoulei-ssl.xunlei.com/pss/static/benefit/config.json'
    : 'http://test.api-shoulei-ssl.xunlei.com/pss/static/benefit/config.json'
  return axios.get(src)
}

export default {
  getCaptcha,
  codeValidate,
  getBenefitConfiguration
}
